import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useGoBack from '@hooks/useGoBack';
import CloseLineIcon from '@icons/CloseLineIcon';
import { pressActionEffect } from '@styles/mixin';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function BottomSheetHeader({ children }:Props) {
    const goBack = useGoBack();
    return (
        <Container>
            {children && (
                <Text size='lg' fontWeight='bold'>
                    {children}
                </Text>
            )}
            <CloseButton color={colors.gray9}
                size={30}
                onClick={goBack} />
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    height: 62px;
    border-bottom: 1px solid var(--color-gray3);
`;

const CloseButton = styled(CloseLineIcon)`
    position: absolute;
    right: 20px;
    ${pressActionEffect}
`;

export default BottomSheetHeader;
